import React, { useState } from 'react';
import { useSearch } from '../../../store/context/SearchContext';
import { useClerk } from '@clerk/clerk-react';

export const CartCard = ({setRunUpdate, initialUnits, product }) => {
  const { addItem, removeItem  , productQuantity ,newCart} = useSearch();
  const { user } = useClerk();
  const [units, setUnits] = useState(initialUnits);
  const [isLoading, setIsLoading] = useState(false);



  const handleQuantityChange = (newUnits) => {
    setUnits(newUnits);
    productQuantity(product.p_id, newUnits);
  };

  async function handleAddItem() {
    setIsLoading(true);
    addItem(product);
    try {
     if(user !== null) {
    let new_user_cart = [];
      
      // const get_user_data = await fetch(`${process.env.REACT_APP_BACKEND_URL_LOCAL}/api/auth-public-users?filters[u_id][$eq]=${user.id}`)
      const get_user_data = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth-public-users?filters[u_id][$eq]=${user.id}`)
  

      const get_user = await get_user_data.json();

     
      // console.log("user handler get_user line 162=================", get_user.data[0]);
    
      const new_user_doc_id = get_user.data[0].documentId
      const new_user_firstName = get_user.data[0].first_name
      const new_user_email = get_user.data[0].email
      const new_user_lastName = get_user.data[0].last_name
      const new_user_uId = get_user.data[0].u_id
      const new_user_ImageUrl = get_user.data[0].image_url
     console.log("++++++++++++++>new_user_ImageUrl", get_user.data[0].cart);
     
      if(get_user.data[0].cart !== undefined && get_user.data[0].cart !== null/*&& get_user.data[0].cart.length >= 1*/){
        get_user.data[0].cart.map((item)=>
          new_user_cart.push(item)
        )
       
      }
//----------------------(2) Step two updating the user cart with old and the new products------------------
      new_user_cart.push(product)
      // const res = await fetch(`${process.env.REACT_APP_BACKEND_URL_LOCAL}/api/auth-public-users/${new_user_doc_id}`, {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth-public-users/${new_user_doc_id}`, {
      
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            first_name: new_user_firstName,
            email: new_user_email,
            last_name: new_user_lastName,
            u_id: new_user_uId,
            image_url: new_user_ImageUrl,
            cart: new_user_cart
          },
        }),
      });
      const dataIn = await res.json();
      console.log("user handler line 164", dataIn);
      // return {
      //   statusCode: 200,
      //   body: JSON.stringify({ message: "cart products is Here " }),
      // }
    }
      // const userInfo = await fetch("/.netlify/functions/userHandler", {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify({
      //     request_type: "cart_products",
      //     products: product, 
      //     user_info: user
      //   })
      // });
      // const data = await res.json();
      // console.log("userInfo from google auth ", data);
      // setUnits(prevUnits => prevUnits + 1);
      handleQuantityChange(units + 1);
    } catch (error) {
      console.error("error from add item", error);
    } finally {
      setIsLoading(false);
    }
  }

  async function handleRemoveItem() {
    setIsLoading(true);
    removeItem(product);
    try {
      // const get_user_data = await fetch(`${process.env.REACT_APP_BACKEND_URL_LOCAL}/api/auth-public-users?filters[u_id][$eq]=${user.id}`)
      const get_user_data = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth-public-users?filters[u_id][$eq]=${user.id}`)
      const get_user = await get_user_data.json();
     
      // console.log("DELETE THE CART 258=================", get_user.data[0]);
      const delete_doc_id = get_user.data[0].documentId
      const delete_user_cart = get_user.data[0].cart
      // console.log("==================>>>>>>DELETE CART  261" , delete_user_cart , ":the product:", product);
   // 2.
      const delete_index_product = delete_user_cart.findIndex((item) => item.p_id === product.p_id);
      delete_user_cart.splice(delete_index_product, 1);
  
    // 3. 
  
    // const res = await fetch(`${process.env.REACT_APP_BACKEND_URL_LOCAL}/api/auth-public-users/${delete_doc_id}`, {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth-public-users/${delete_doc_id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        data: {
          first_name: user.firstName,
          email: user.primaryEmailAddress.emailAddress,
          last_name: user.lastName,
          u_id: user.id,
          image_url: user.imageUrl,
          cart: delete_user_cart
        },
      }),
    });
      // const userInfo = await fetch("/.netlify/functions/userHandler", {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify({
      //     request_type: "remove_product_from_cart",
      //     product: product, 
      //     user_info: user
      //   })
      // });
      const data = await res.json();
      console.log("userInfo from google auth RemoveItem line 56", data.new_cart);
      const new_cart = data.new_cart
      newCart(new_cart)
        setRunUpdate(false)
      
    } catch (error) {
      console.error("error from remove item", error);
    } finally {
      setIsLoading(false);
    }
  }
  console.log("product.overview", product);
  console.log("product.overview", product.poster.url);
  


  return (
    units > 0 ?
    <div className="flex items-center border-b border-gray-200 py-4">
      <div className=' mr-5 font-mono font-bold text-lg text-gray-200 '>{product.price}$</div>
      {/* <img src={`${process.env.REACT_APP_BACKEND_URL_LOCAL}` + product.poster.url} alt={product.name} className="w-20 h-20 object-cover mr-4" /> */}
      <img src={`${process.env.REACT_APP_BACKEND_URL}` + product.poster.url} alt={product.name} className="w-20 h-20 object-cover mr-4" />
      <img src={ product.poster.url} alt={product.name} className="w-20 h-20 object-cover mr-4" />
      <div className="flex-grow">
        <h3 className="text-lg text-end mt-2 mr-5 font-semibold">{product.name}</h3>
        <p className="text-sm text-end  mr-5 text-gray-200">{product.over_view}...</p>
      </div>
      <div className="flex items-center">
        <button onClick={handleRemoveItem} className="px-2 py-1 bg-red-500 text-white rounded">-</button>
        <span className="mx-2">
          {isLoading ? (
            <div className="w-4 h-4 border-2 border-gray-300 border-t-2 border-t-blue-500 rounded-full animate-spin"></div>
          ) : (
            units
          )}
        </span>
        <button onClick={handleAddItem} className="px-2 py-1 bg-green-500 text-white rounded">+</button>
      </div>
    </div>
    :
    <div>
      <h1>Product is been removed from cart</h1>
      
    </div>
  );
};
